<template>
  <div>
    <el-upload
      action=""
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :before-upload="handleBeforeUpload"
      :limit="uploadLimit"
      :http-request="handleUpload"
      ref="uploadRef"
      :accept="acceptAttr"
      :on-exceed="handleOnExceed"
      :multiple="uploadLimit > 1"
    >
      <el-button icon="el-icon-upload" :loading="uploadLoading"
        >上传附件</el-button
      >
      <div slot="tip" class="el-upload__tip" style="margin-top: 0">
        单个文件不超过{{ maxSize }}M，最多{{ uploadLimit }}个，可上传({{
          mergedFileTypes.join("/")
        }})
      </div>
    </el-upload>
  </div>
</template>

<script>
import api from "plus/api";

export default {
  name: "workOrderFileUpload",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    maxSize: {
      type: Number,
      default: 500,
    },
    /** 最大上传文件数 */
    uploadLimit: {
      type: Number,
      default: 1,
    },
    /** 追加允许的扩展名，如 ['.jpg','.png'] */
    extraFileTypes: {
      type: Array,
      default: () => [],
    },
  },
  deactivated() {
    this.$refs.uploadRef.clearFiles();
  },
  data() {
    return {
      fileTypeEnum: [
        ".pdf",
        ".rar",
        ".zip",
        ".txt",
        ".doc",
        ".docx",
        ".xls",
        ".xlsx",
        ".csv",
      ],
      uploadLoading: false,
    };
  },
  computed: {
    mergedFileTypes() {
      const base = this.fileTypeEnum || [];
      const extra = this.extraFileTypes || [];
      return [...new Set([...base, ...extra])];
    },
    acceptAttr() {
      return this.mergedFileTypes.join(",");
    },
  },
  methods: {
    handleOnExceed() {
      this.$message.error(`当前最多上传${this.uploadLimit}个文件`);
    },
    handleRemove(file, fileList) {
      const allFileList = this.list.filter((item) => item.uid !== file.uid);
      this.$emit("update:list", allFileList);
    },
    handlePictureCardPreview(file) {
      console.log(file);
    },
    handleBeforeUpload(file) {
      const lower = file.name.toLowerCase();
      const isImage = this.mergedFileTypes.some((item) =>
        lower.endsWith(item.toLowerCase()),
      );
      if (!isImage) {
        this.$message.error("上传文件类型错误");
        return false;
      }
      const fileSize = this.checkFileSize(file);
      if (fileSize) {
        this.$message.error("文件大小超出限制");
        return false;
      }
    },
    checkFileSize(file) {
      return file.size / 1024 > this.maxSize * 1024;
    },
    async handleUpload(params) {
      this.uploadLoading = true;
      this.$emit("uploadLoading", true);
      const {
        data: {
          data: { token, fileName },
        },
      } = await api.qiniu.getToken({
        fileName: params.file.name,
      });
      let index = params.file.name.lastIndexOf(".");
      let name = params.file.name.substr(index);
      const formData = new FormData();
      formData.append("fileName", fileName);
      formData.append("file", params.file);
      formData.append("key", fileName + name);
      formData.append("token", token);
      const response = await api.qiniu.upload(formData);
      const allFileList = [
        ...this.list,
        {
          attachmentType: "FILE",
          appendisUrl: `https://cdn-workorder.meb.com/${response.data.key}`,
          uid: params.file.uid,
        },
      ];
      this.uploadLoading = false;
      this.$emit("update:list", allFileList);
      this.$emit("uploadLoading", false);
    },
    clearData() {
      this.$refs.uploadRef.clearFiles();
      this.uploadLoading = false;
      this.$emit("uploadLoading", false);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 98px;
}
</style>
